import { memo } from 'react';
import { twcls } from '@utils/twcls';
import type { ClassValue } from 'clsx';
import './index.scss';

interface LoadingPageProps {
  smallMt?: boolean;
  fullHeight?: boolean;
  className?: ClassValue;
}

const LoadingPage = memo(
  ({ smallMt, fullHeight, className }: LoadingPageProps) => (
    <div
      className={twcls(
        `loading-container`,
        fullHeight && 'loading-container--full-h',
        smallMt && 'loading-container--small-mt',
        className
      )}
    >
      <div className='loading'>
        <div />
        <div />
      </div>
    </div>
  )
);

export default LoadingPage;
